module.exports = __webpack_public_path__ + "static/media/lpq-rewards-hero-bg.e24264fb.png";